export default {
	init() {
		// JavaScript to be fired on the What we do page

		

		$('.expand-one').click(function () {
			$('.content-one').slideToggle('slow');
			var $this = $('#panel1');
			var $image = $('#image1');
			if ($this.hasClass('plan-heading')) {
				$this.removeClass('plan-heading').addClass('plan-heading1');
				$image.attr('src','../../../app/themes/sage9-Creative-Economy/dist/images/arrow-button.svg');
			}
			else if ($this.hasClass('plan-heading1')) {
				$this.removeClass('plan-heading1').addClass('plan-heading');
				$image.attr('src','../../../app/themes/sage9-Creative-Economy/dist/images/plus-button.svg');
			}
		});

		$('.expand-two').click(function () {
			$('.content-two').slideToggle('slow');
			var $this = $('#panel2');
			var $image = $('#image2');
			if ($this.hasClass('plan-heading')) {
				$this.removeClass('plan-heading').addClass('plan-heading1');
				$image.attr('src','../../../app/themes/sage9-Creative-Economy/dist/images/arrow-button.svg');
			}
			else if ($this.hasClass('plan-heading1')) {
				$this.removeClass('plan-heading1').addClass('plan-heading');
				$image.attr('src','../../../app/themes/sage9-Creative-Economy/dist/images/plus-button.svg');
			}
		});

		$('.expand-three').click(function () {
			$('.content-three').slideToggle('slow');
			var $this = $('#panel3');
			var $image = $('#image3');
			if ($this.hasClass('plan-heading')) {
				$this.removeClass('plan-heading').addClass('plan-heading1');
				$image.attr('src','../../../app/themes/sage9-Creative-Economy/dist/images/arrow-button.svg');
			}
			else if ($this.hasClass('plan-heading1')) {
				$this.removeClass('plan-heading1').addClass('plan-heading');
				$image.attr('src','../../../app/themes/sage9-Creative-Economy/dist/images/plus-button.svg');
			}
		});

		$('.expand-four').click(function () {
			$('.content-four').slideToggle('slow');
			var $this = $('#panel4');
			var $image = $('#image4');
			if ($this.hasClass('plan-heading')) {
				$this.removeClass('plan-heading').addClass('plan-heading1');
				$image.attr('src','../../../app/themes/sage9-Creative-Economy/dist/images/arrow-button.svg');
			}
			else if ($this.hasClass('plan-heading1')) {
				$this.removeClass('plan-heading1').addClass('plan-heading');
				$image.attr('src','../../../app/themes/sage9-Creative-Economy/dist/images/plus-button.svg');
			}
		});

		$('.expand-five').click(function () {
			$('.content-five').slideToggle('slow');
			var $this = $('#panel5');
			var $image = $('#image5');
			if ($this.hasClass('plan-heading')) {
				$this.removeClass('plan-heading').addClass('plan-heading1');
				$image.attr('src','../../../app/themes/sage9-Creative-Economy/dist/images/arrow-button.svg');
			}
			else if ($this.hasClass('plan-heading1')) {
				$this.removeClass('plan-heading1').addClass('plan-heading');
				$image.attr('src','../../../app/themes/sage9-Creative-Economy/dist/images/plus-button.svg');
			}
		});

		$('.expand-six').click(function () {
			$('.content-six').slideToggle('slow');
			var $this = $('#panel6');
			var $image = $('#image6');
			if ($this.hasClass('plan-heading')) {
				$this.removeClass('plan-heading').addClass('plan-heading1');
				$image.attr('src','../../../app/themes/sage9-Creative-Economy/dist/images/arrow-button.svg');
			}
			else if ($this.hasClass('plan-heading1')) {
				$this.removeClass('plan-heading1').addClass('plan-heading');
				$image.attr('src','../../../app/themes/sage9-Creative-Economy/dist/images/plus-button.svg');
			}
		});

		// $('#showHeader').on('click',function() {
		// 	$('#nav-menu').toggle();
		// });
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/whatWeDo.js